import { render, staticRenderFns } from "./wageTotal.vue?vue&type=template&id=897b7656&scoped=true&"
import script from "./wageTotal.vue?vue&type=script&lang=js&"
export * from "./wageTotal.vue?vue&type=script&lang=js&"
import style0 from "./wageTotal.vue?vue&type=style&index=0&id=897b7656&scoped=true&lang=css&"
import style1 from "./wageTotal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897b7656",
  null
  
)

export default component.exports